import React, { useEffect, useState } from 'react';
import SaveModal from '../modal/saveModal';

function DepositContract() {
    const [modalAction, setModalAction] = useState(null);
    const [modalContent, setModalContent] = useState(null);
    const [saveStatus, setSaveStatus] = useState(true);
    
    const isLocal = window.location.hostname != 'wpal.philippineair.co.kr';
    const domain = isLocal ? process.env.REACT_APP_LOCAL_API_URL : process.env.REACT_APP_PRODUCTION_API_URL;
    const searchParams = new URLSearchParams(window.location.search);
    const key = searchParams.get('key');

    useEffect(() => {
        if (!key) {
            setModalContent('404 NOT FOUND');
            setSaveStatus(false);
            setModalAction(() => () => {
                window.location.href = '/';
            })
            return null
        }
        
    },[])
    
    const iframeSrc = `${domain}/public/wpal/deposit-contract?key=${key || ''}`;
    
    return (
        <div style={{ marginTop: '96px' }}>
            {!key ? 
                <></> : 
                <iframe
                    src={`${iframeSrc}`}
                    style={{ width: '100%', height: 'calc(99vh - 93px)' }}
                ></iframe>
            }
            <SaveModal content={modalContent} SaveBtn={saveStatus} onClose={modalAction} />
        </div>
    );
}

export default DepositContract;
